import axios from "axios";
import { getCookie } from "../../utils/cookies";
import {
  MUX_ANALYTICS_LOADING,
  MUX_ANALYTICS_ERROR,
  FETCH_QOE_OVERVIEW,
  FETCH_QOE_BY_DEVICE,
  FETCH_QOE_BY_PLAN,
  FETCH_QOE_BY_CATEGORY,
  FETCH_QOE_BY_DIFFICULTY,
  FETCH_QOE_TIMESERIES,
  FETCH_TRAIL_QOE,
  FETCH_TRAIL_ENGAGEMENT,
  FETCH_TRAIL_FUNNEL,
  FETCH_MODULE_QOE,
  FETCH_MODULE_DROP_OFF,
  FETCH_VIDEO_QOE,
  FETCH_VIDEO_ENGAGEMENT,
  FETCH_CONCURRENT_VIEWERS,
  FETCH_STARTUP_HEALTH,
} from "./types";

const API_URL = process.env.REACT_APP_GOLANG_API;

const setAuthHeader = () => {
  const token = getCookie("_session");
  if (token) {
    try {
      axios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(token)}`;
    } catch {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }
};

const buildQs = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  return qs.toString();
};

// --- QoE Overview ---
export const fetchQoEOverview = (timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { qoeOverview: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/qoe/overview?${qs}`);
    dispatch({ type: FETCH_QOE_OVERVIEW, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

// --- QoE Breakdowns ---
export const fetchQoEByDevice = (timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { qoeBreakdowns: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/qoe/by-device?${qs}`);
    dispatch({ type: FETCH_QOE_BY_DEVICE, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchQoEByPlan = (timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { qoeBreakdowns: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/qoe/by-plan?${qs}`);
    dispatch({ type: FETCH_QOE_BY_PLAN, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchQoEByCategory = (timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { qoeBreakdowns: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/qoe/by-category?${qs}`);
    dispatch({ type: FETCH_QOE_BY_CATEGORY, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchQoEByDifficulty = (timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { qoeBreakdowns: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/qoe/by-difficulty?${qs}`);
    dispatch({ type: FETCH_QOE_BY_DIFFICULTY, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

// --- QoE Timeseries ---
export const fetchQoETimeseries = (timeframe = "7:days", metric = "viewer_experience_score") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { qoeTimeseries: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe, metric });
    const res = await axios.get(`${API_URL}/api/v2/analytics/qoe/timeseries?${qs}`);
    dispatch({ type: FETCH_QOE_TIMESERIES, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

// --- Trail Drill-down ---
export const fetchTrailQoE = (trailId, timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { trailQoe: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/trails/${trailId}/qoe?${qs}`);
    dispatch({ type: FETCH_TRAIL_QOE, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchTrailEngagement = (trailId, timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { trailEngagement: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/trails/${trailId}/engagement?${qs}`);
    dispatch({ type: FETCH_TRAIL_ENGAGEMENT, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchTrailFunnel = (trailId) => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { trailFunnel: true } });
    setAuthHeader();
    const res = await axios.get(`${API_URL}/api/v2/analytics/trails/${trailId}/funnel`);
    dispatch({ type: FETCH_TRAIL_FUNNEL, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

// --- Module Drill-down ---
export const fetchModuleQoE = (moduleId, timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { moduleQoe: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/modules/${moduleId}/qoe?${qs}`);
    dispatch({ type: FETCH_MODULE_QOE, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchModuleDropOff = (moduleId, timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { moduleDropOff: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/modules/${moduleId}/drop-off?${qs}`);
    dispatch({ type: FETCH_MODULE_DROP_OFF, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

// --- Video Drill-down ---
export const fetchVideoQoE = (videoId, timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { videoQoe: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/videos/${videoId}/qoe?${qs}`);
    dispatch({ type: FETCH_VIDEO_QOE, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchVideoEngagement = (videoId, timeframe = "7:days") => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { videoEngagement: true } });
    setAuthHeader();
    const qs = buildQs({ timeframe });
    const res = await axios.get(`${API_URL}/api/v2/analytics/videos/${videoId}/engagement?${qs}`);
    dispatch({ type: FETCH_VIDEO_ENGAGEMENT, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

// --- Monitoring ---
export const fetchConcurrentViewers = (trailId) => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { monitoring: true } });
    setAuthHeader();
    const qs = buildQs({ trailId });
    const res = await axios.get(`${API_URL}/api/v2/analytics/monitoring/concurrent-viewers?${qs}`);
    dispatch({ type: FETCH_CONCURRENT_VIEWERS, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const fetchStartupHealth = () => async (dispatch) => {
  try {
    dispatch({ type: MUX_ANALYTICS_LOADING, payload: { monitoring: true } });
    setAuthHeader();
    const res = await axios.get(`${API_URL}/api/v2/analytics/monitoring/startup-health`);
    dispatch({ type: FETCH_STARTUP_HEALTH, payload: res.data });
  } catch (error) {
    dispatch({ type: MUX_ANALYTICS_ERROR, payload: error.response?.data?.message || error.message });
  }
};
